import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import { useOwnezzyContact } from './contact';

// /terms and /privacy on ownezzy.com. docFor(contact) builds the page with Ownezzy's current contact.
export default function LegalPage({ docFor }) {
  const contact = useOwnezzyContact();
  const doc = docFor(contact);
  useEffect(() => {
    document.title = `${doc.title} | Ownezzy`;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.setAttribute('content', `Ownezzy ${doc.title}: how the free online store platform for shop and business owners works, what sellers are responsible for, and how data is handled.`);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `https://ownezzy.com${window.location.pathname}`);
    window.scrollTo(0, 0);
  }, [doc.title]);

  return (
    <div className="app-shell">
      <AnnouncementBar />
      <Navbar />
      <main className="legal-page">
        <div className="container">
          <article className="legal-article">
            <a className="legal-back" href="/">← Back to Ownezzy</a>
            <h1>{doc.title}</h1>
            <p className="legal-updated">Last updated: {doc.lastUpdated || contact.lastUpdated}</p>
            {doc.intro.map((p) => <p key={p}>{p}</p>)}
            {/* The points every reader must not miss (Terms: what Ownezzy is and is not responsible for) */}
            {doc.highlight && (
              <aside className="legal-highlight" aria-label={doc.highlight.title}>
                <h2>{doc.highlight.title}</h2>
                <ul>{doc.highlight.list.map((item) => <li key={item}>{item}</li>)}</ul>
              </aside>
            )}
            {doc.sections.map((section) => (
              <section key={section.heading}>
                <h2>{section.heading}</h2>
                {(section.text || []).map((p) => <p key={p}>{p}</p>)}
                {section.list && <ul>{section.list.map((item) => <li key={item}>{item}</li>)}</ul>}
                {(section.after || []).map((p) => <p key={p}>{p}</p>)}
              </section>
            ))}
            <p className="legal-links"><a href="/terms">Terms of Service</a> · <a href="/privacy">Privacy Policy</a></p>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
}
